/**
 * Directional tilt down gesture
 * @module gestures/transforms/tiltDown
 */
import { createTiltGesture } from './tiltFactory.js';
export default createTiltGesture('down');
